var Swiper;
var WebSite;
(function (WebSite) {
    var AFWSwiper = (function () {
        function AFWSwiper(element, swiperSettings) {
            if (swiperSettings === void 0) { swiperSettings = null; }
            this.SwiperSettings = null;
            var swpSetJson = swiperSettings || element.getAttribute('data-swiper-settings');
            if (swpSetJson) {
                this.SwiperSettings = JSON.parse(swpSetJson);
            }
            new Swiper(element, this.SwiperSettings);
        }
        return AFWSwiper;
    }());
    WebSite.AFWSwiper = AFWSwiper;
    var Main = (function () {
        function Main() {
            var _this = this;
            this.findToCount = function () {
                var numberToCount = $("div.numberCount");
                for (var i = 0; i < numberToCount.length; i++) {
                    _this.countToNumber(numberToCount[i]);
                }
            };
            this.countToNumber = function (numberToCount) {
                setTimeout(start, 1);
                var toNumber = parseInt($(numberToCount).attr("countto"));
                var i = 0;
                function start() {
                    setInterval(increase, 5);
                }
                function increase() {
                    if (i < toNumber) {
                        i++;
                        $(numberToCount).text(i);
                    }
                }
            };
            this.fileEvent = function () {
                $("div.hiddenUpload").change(function () {
                    var filePath = $("div.hiddenUpload input").val().toString();
                    var file = jQuery.trim(filePath).split("\\");
                    $("div.replText").text(file[file.length - 1]);
                });
            };
            this.chooseFile = function () {
                $("div.replButton").on("click", function () {
                    document.getElementById("UploadedFile").click();
                });
            };
            this.openVideoModal = function () {
                $(".webinar-video-wrapper").on("click", function (data) {
                    var videoCode = $(data.currentTarget).attr("video-url");
                    var video = "https://www.youtube.com/embed/" + videoCode;
                    $(".modal .modal-dialog .modal-body iframe").attr("src", video);
                });
            };
            this.hangWebsiteSubmitForms = function () {
                var elements = document.querySelectorAll('[data-wssubmitform]');
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    hangAsyncSubmitToForm(el);
                }
            };
            this.bindSwiperTmpFunc = function () {
                var elements = document.querySelectorAll('[data-swiper-init]');
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    new WebSite.AFWSwiper(el);
                }
            };
            this.responsiveIframe = function () {
                var iframe = $('.livePreviewModal iframe');
                if (iframe.length == 0) {
                    return;
                }
                $('#livePreviewModal').on('shown.bs.modal', function () {
                    setIframeHeight(iframe);
                });
                $(window).on('resize', function () {
                    setIframeHeight(iframe);
                });
            };
            this.modalImageSetSrc = function () {
                var swiper = new Swiper('.modal-swiper', {
                    SlidesPerView: 1,
                    SpaceBetween: 10,
                    loop: true,
                    navigation: {
                        nextEl: '.swiperAdvantagesBN',
                        prevEl: '.swiperAdvantagesBP',
                    },
                    observer: true,
                    observeParents: true
                });
                $('.show-more').click(function () {
                    var imageSwiperPopup = document.querySelector('.imageSwiperPopup').swiper;
                    if (imageSwiperPopup) {
                        swiper.slideTo(imageSwiperPopup.activeIndex);
                    }
                });
            };
            this.openDesktopSearch = function () {
                var searchBtn = $('.searchDesktop .searchBtnDesktop');
                var inputSearch = $('.searchDesktop input');
                var searchForm = $('.searchDesktop form');
                searchBtn.click(function () {
                    if (inputSearch.is(':visible')) {
                        if (inputSearch.val() != '') {
                            searchForm.submit();
                        }
                        else {
                            inputSearch.hide();
                            searchBtn.removeClass('active');
                        }
                    }
                    else {
                        inputSearch.val('');
                        inputSearch.show();
                        searchBtn.addClass('active');
                        inputSearch.focus();
                    }
                });
            };
            this.openMobileSearch = function () {
                var searchBtn = $('.searchBtnMobile');
                var inputSearch = $('.searchMobile');
                var searchForm = $('.searchMobile form');
                searchBtn.click(function () {
                    if (inputSearch.is(':visible')) {
                        if (inputSearch.val() != '') {
                            searchForm.submit();
                        }
                        else {
                            inputSearch.hide();
                            searchBtn.removeClass('active');
                        }
                    }
                    else {
                        inputSearch.val('');
                        inputSearch.show();
                        searchBtn.addClass('active');
                    }
                });
            };
            this.getMenuActiveItem = function () {
                var url = window.location.href;
                $('.navbar-nav ul li a').each(function () {
                    if (this instanceof HTMLAnchorElement && this.href === url) {
                        $(this).addClass('active');
                    }
                });
            };
            this.chooseFile();
            this.fileEvent();
            this.openVideoModal();
            this.hangWebsiteSubmitForms();
            this.bindSwiperTmpFunc();
            this.responsiveIframe();
            this.openDesktopSearch();
            this.modalImageSetSrc();
            this.openMobileSearch();
            this.getMenuActiveItem();
            this.findToCount();
            var nav = new hcOffcanvasNav('#menuMobile', {
                disableAt: 1024,
                customToggle: $('#toggleMenu'),
                levelTitles: true,
                levelTitleAsBack: false,
                levelSpacing: 0,
                labelBack: '',
                width: 450
            });
        }
        return Main;
    }());
    WebSite.Main = Main;
    function setIframeHeight(iframe) {
        var iframeVisible = iframe.is(':visible');
        if (!iframeVisible) {
            return;
        }
        var win = $(this);
        if (win.width() < 1200) {
            var width = iframe.width();
            var height = width / 1.35;
            iframe.height(height);
        }
        else {
            iframe.height(770);
        }
    }
    function hangAsyncSubmitToForm(form) {
        form.addEventListener('submit', function (e) {
            var formEl = $(this);
            if (!formEl.valid())
                return;
            e.preventDefault();
            grecaptcha.ready(function () {
                grecaptcha.execute('6LdL4joeAAAAADtoBXUACtuXlmU6clshtaXwEfOZ', { action: 'submit' }).then(function (token) {
                    var allData = AllForWeb.getFormData(form);
                    $.ajax({
                        type: "POST",
                        dataType: "JSON",
                        method: "POST",
                        processData: false,
                        contentType: false,
                        data: allData
                    }).then(function (result) {
                        var formResponse = formEl.find(".form-respons");
                        formResponse.show();
                        $(".download-box a#fancy-brochure")[0].click();
                        var formStructure = formEl.find(".form-submit");
                        formStructure.hide();
                        setTimeout(function () {
                            formEl.find('input').not('[type=hidden], [type=checkbox]').val('');
                            var formResponse = formEl.find(".form-respons");
                            formResponse.hide();
                            var formStructure = formEl.find(".form-submit");
                            formStructure.show();
                        }, 3000);
                    }, function (err) {
                        console.log("Error: ", err);
                    });
                });
            });
        });
    }
    WebSite.hangAsyncSubmitToForm = hangAsyncSubmitToForm;
})(WebSite || (WebSite = {}));
function showAll(data) {
    var currentDisplay = $("." + data + " .invisible-box").css("display");
    var button = $("." + data + " .section-title a.button");
    var buttonText = $("." + data + " .section-title a.button" + " div");
    if (currentDisplay === "none") {
        $("." + data + " .invisible-box").css("display", "flex");
        $(buttonText).text($(button).attr("showless"));
    }
    else {
        $("." + data + " .invisible-box").css("display", "none");
        $(buttonText).text($(button).attr("showmore"));
    }
}
function setCookieConsents() {
    var domain = window.location.hostname;
    var cookieWarning = $(".cookie-dialog");
    $(".cookie-switch").on('click', function () {
        console.log("clicked!");
    });
}
(function () {
    addAnimationBlock();
    reveal();
    new WebSite.Main();
    new AllForWeb.FormSubmit();
    var domainName = window.location.hostname;
    var cookieMain = $('#new-cookie-notice');
    var cookieWarning = $(".cookie-dialog", cookieMain);
    $("#accept-cookies", cookieMain).on('click', function () {
        Cookies.set("analytic_consent", "1", { expires: 365, path: '/', domain: domainName });
        Cookies.set("marketing_consent", "1", { expires: 365, path: '/', domain: domainName });
        Cookies.set("cookie_consentNoPopUp", "1", { expires: 30, path: "/", domain: domainName });
        $(cookieMain).fadeOut();
        window.location.reload();
    });
    var analytics_cookie_value = Cookies.get('analytic_consent');
    var marketing_cookie_value = Cookies.get('marketing_consent');
    var cookieCheckboxes = $(".cookie-checkbox");
    cookieCheckboxes.each(function () {
        var type = $(this).attr("cookie-type");
        if (type == "analytics") {
            if (analytics_cookie_value == "1") {
                $(this).prop('checked', true);
            }
        }
        if (type == "marketing") {
            if (marketing_cookie_value == "1") {
                $(this).prop('checked', true);
            }
        }
    });
    $("#btnShowCookieChoice").on('click', function () {
        $("#accordionCookieTypes").fadeIn();
        $("#btnShowCookieChoice").hide();
        $("#btnSaveCookieChoice").fadeIn();
    });
    $("#btnSaveCookieChoice").on('click', function () {
        var checkboxes = $(".cookie-checkbox");
        checkboxes.each(function () {
            var type = $(this).attr("cookie-type");
            var checked = $(this).is(":checked");
            if (type == "analytics") {
                if (checked) {
                    console.log("create analytics cookie");
                    Cookies.set("analytic_consent", "1", { expires: 365, path: '/', domain: domainName });
                }
                else {
                    console.log("delete analytics cookie");
                    Cookies.remove("analytic_consent");
                }
            }
            else if (type == "marketing") {
                if (checked) {
                    console.log("create marketing cookie");
                    Cookies.set("marketing_consent", "1", { expires: 365, path: '/', domain: domainName });
                }
                else {
                    console.log("delete marketing cookie");
                    Cookies.remove("marketing_consent");
                }
            }
        });
        Cookies.set("cookie_consentNoPopUp", "1", { expires: 30, path: "/", domain: domainName });
        $("#new-cookie-notice").fadeOut();
        window.location.reload();
    });
    function showPopupBanner() {
        var showPopupCookie = Cookies.get('cookie_showPopupBanner');
        if (!showPopupCookie) {
            var domainName = window.location.hostname;
            Cookies.set("cookie_showPopupBanner", "1", { expires: 30, path: "/", domain: domainName });
            $(".popup-main").addClass('popup-open');
        }
        else if (showPopupCookie == "1") {
            $(".popup-main").addClass('popup-open');
        }
    }
    window.addEventListener("load", showPopupBanner, false);
    $('#closePopupBanner').on('click', function () {
        $(".popup-main").removeClass('popup-open');
        var domainName = window.location.hostname;
        Cookies.set("cookie_showPopupBanner", "0", { expires: 30, path: "/", domain: domainName });
    });
    var isSubmitAllowed = true;
    $(".contact-form-submit.form-submit button").on('click', function () {
        if (!isSubmitAllowed) {
            return;
        }
        isSubmitAllowed = false;
        var nameLen = $(".career-contact-form input#NameSurrname").val().toString().length > 0;
        var emailLen = $(".career-contact-form input#EmailAddres").val().toString().length > 0;
        var consentLen = $(".career-contact-form input#Consent").is(":checked");
        if (nameLen && emailLen && consentLen) {
            $(".contact-form-submit.form-submit button").addClass("button-career-disabled");
        }
    });
    $(".BlocksAccordions.clickable-images .accordion .accordion-body img").on("mouseenter", function () {
        var parentLi = $(this).closest("li");
        $(parentLi).css("position", "relative");
        var imgPosition = $(this).position();
        $(this).after("<div class=\"overlay-div\" style=\"position: absolute; bottom: 0; left: " + imgPosition.left + "px; width: " + $(this).width() + "px; height: " + $(this).height() + "px; pointer-events: none; display: flex; justify-content: center; align-items: center;\"><img src=\"/Content/Images/view_more_icn.svg\" alt=\"Click to make bigger\"></div>");
    }).on("mouseleave", function () {
        $(this).siblings(".overlay-div").remove();
    }).on("click", function () {
        $("#closeUpImageModal").modal('show');
        $("#closeUpImageModal img").attr("src", $(this).attr("src").split("?width")[0]);
        console.log("tole se je kliknilo in zdaj bo BUM kaBUM");
    });
    function addAnimationBlock() {
        $(".animateImages .around-image").append("<div class='animationSquare'></div>");
    }
    function reveal() {
        var reveals = document.querySelectorAll(".animateImages .around-image");
        for (var i = 0; i < reveals.length; i++) {
            var windowHeight = window.innerHeight;
            var elementTop = reveals[i].getBoundingClientRect().top;
            var elementVisible = 10;
            if (elementTop < windowHeight - elementVisible) {
                reveals[i].classList.add("active");
            }
        }
    }
    function shrinkPromoBanner() {
        if ($(this).scrollTop() > 0) {
            $(".promoBanner").addClass("shrinked");
        }
        else {
            $(".promoBanner").removeClass("shrinked");
        }
    }
    window.addEventListener('scroll', function () {
        reveal();
        shrinkPromoBanner();
    });
    var elements = document.querySelectorAll("#toggleNav, .navParent, .navChild, .closeNavBtn, .navDesktopBottom");
    for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener("click", function () {
            var nav = document.getElementById("navDesktop");
            var btn = document.getElementById("toggleNav");
            nav.classList.toggle("active");
            btn.classList.toggle("active");
            $('body').toggleClass('fixedBody');
        });
    }
    var targetElements = document.querySelectorAll(".information-card");
    function isElementInViewport(element) {
        var rect = element.getBoundingClientRect();
        return rect.top <= (window.innerHeight || document.documentElement.clientHeight);
    }
    function handleScroll() {
        targetElements.forEach(function (element) {
            if (isElementInViewport(element)) {
                $(element).addClass("is-visible");
            }
        });
    }
    window.addEventListener('scroll', handleScroll);
    handleScroll();
})();
function focusOnSearch() {
}
//# sourceMappingURL=Main.js.map